import React from 'react';
import '../documents/ReportModal/ReportModal.css';

const SimpleModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="report-modal-header">
          {title ? <h2>{title}</h2> : <div />}
          <button onClick={onClose} className="close-button">×</button>
        </div>
        <div className="report-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SimpleModal;
